<script lang="ts">
  // Editor section "Betaling" (existing entries): status, amount paid, what is
  // still outstanding and the invoice number.
  import '../../messages/entries';
  import '../../messages/ui';
  import { Button, Field, Input, MoneyInput, Select } from '../../ui';
  import { t } from '../../i18n.svelte';
  import { formatMoney } from '../../format';
  import { STATUSES, type Status } from '../helpers';
  import EditorSection from './EditorSection.svelte';
  import type { EntryForm } from './form.svelte';

  let { form }: { form: EntryForm } = $props();

  const statusOptions = $derived(STATUSES.map((s) => ({ value: s, label: t(`payment.${s}`) })));
</script>

<EditorSection title={t('entries.section_payment')}>
  <div class="grid-2 pair">
    <Field label={t('field.status')} for={form.id('status')}>
      <Select id={form.id('status')} value={form.status} options={statusOptions} onchange={(e) => form.setStatus(e.currentTarget.value as Status)} />
    </Field>
    <Field label={t('entries.amount_paid')} for={form.id('paid')} error={form.show('amountPaid')}>
      <MoneyInput id={form.id('paid')} bind:value={form.amountPaid} disabled={form.status === 'non_billable'} />
    </Field>
  </div>
  {#if form.status !== 'non_billable'}
    <p class="outstanding">
      {t('entries.outstanding_label')}: <strong class="tabular">{formatMoney(form.outstanding)}</strong>
      {#if form.outstanding > 0 && form.status !== 'paid'}
        <Button variant="subtle" size="sm" onclick={() => form.setStatus('paid')}>{t('entries.mark_fully_paid')}</Button>
      {/if}
    </p>
  {/if}
  <Field label={t('entries.invoice_reference')} for={form.id('invoice')} error={form.show('invoice')} hint={t('entries.invoice_hint')} optional optionalLabel={t('common.optional')}>
    <Input id={form.id('invoice')} bind:value={form.invoiceRef} maxlength={50} placeholder="2026-001" invalid={!!form.show('invoice')} />
  </Field>
</EditorSection>

<style>
  .pair { align-items: start; }
  .outstanding { display: flex; align-items: center; flex-wrap: wrap; gap: var(--space-2); margin-top: calc(var(--space-2) * -1); font-size: var(--text-base); color: var(--text-2); }
  .outstanding strong { color: var(--text); }
</style>
